import { ContentWithMessage } from '@knowledge/knowledges/SupplementKnowledge/AdjustRelateKnowledge/ContentWithMessage';
import { EmptyPlaceholder } from '@knowledge/knowledges/SupplementKnowledge/EmptyPlaceholder';
import { useTranslate } from '@tolgee/react';
import { useRequest } from 'ahooks';
import { Drawer, DrawerProps, message } from 'antd';
import { FullLoading } from 'components/FullLoading';
import useModal from 'hooks/useModal';
import { getMercadoQaSupplementKnowledgeDetail } from 'services/api/supplementKnowledge';
import { MercadoItemFAQQuestion } from './services';
import { productList } from 'services/api/conversation';

interface Props extends DrawerProps {
  question: MercadoItemFAQQuestion;
  externalItemId: string;
}

function QAPairDrawer({ question, externalItemId, ...otherProps }: Props) {
  const { t } = useTranslate();

  const { data, loading } = useRequest(
    () => {
      return Promise.all([
        getMercadoQaSupplementKnowledgeDetail(question.id),
        productList({
          internal_store_id: question.storeId,
          external_item_ids: externalItemId,
          page_no: 1,
          page_size: 1,
        }).then((res) => {
          const item = res.itemList?.[0];
          if (item) {
            return {
              ...item,
              shopId: item.externalShopId,
            };
          }
        }),
      ]);
    },
    {
      refreshDeps: [question.id],
      onError: () => message.error(t('phrase.获取数据失败，请稍后再试')),
    },
  );

  return (
    <Drawer
      title={t('调整相关知识')}
      width={640}
      bodyStyle={{
        padding: 0,
      }}
      {...otherProps}
    >
      {loading ? (
        <FullLoading />
      ) : data ? (
        <ContentWithMessage
          externalQuestionId={question.id}
          knowledgeQuery={{
            fromUserName: question.userNick,
            region: question.region,
            channel: 'MERCADO',
            storeId: question.storeId,
            textContent: {
              text: question.text,
              originalText: '',
              translationContent: {},
            },
            itemInfo: data[1],
          }}
          supplementKnowledgeDetail={data[0]}
          onDone={() => otherProps.onClose?.({} as any)}
        />
      ) : (
        <EmptyPlaceholder />
      )}
    </Drawer>
  );
}

export function useQAPairDrawer() {
  const { visible, show, hide, meta } = useModal<Props>();

  const drawer = meta && <QAPairDrawer {...meta} visible={visible} onClose={() => hide()} />;

  return [drawer, show] as const;
}

export default QAPairDrawer;
